<app-auto-page-heading [isCarrier]="!isGlobalUser"
                       [(selectedRegion)]="selectedRegion"
                       (selectedRegionChange)="updateSelectedRegion($event)"
                       [(selectedCarrier)]="selectedCarrier"
                       (selectedCarrierChange)="updateSelectedCarrier($event)"
                       [localStorageKeyPrefix]="'overdue-process'"
                       [title]="'overdue-process.blue-tracking-title'"
                       [selectCarrierPlaceholder]="'overdue-process.page-heading-carriers-placeholder'"
                       (onCarrierFetchError)="handleHeaderCarrierFetchErrors($event)"
                       (onRegionFetchError)="handleHeaderRegionFetchErrors($event)"
                       [clearable]="isGlobalUser"
                       [needVendorNumber]="true">
</app-auto-page-heading>

<spacer [size]="16"></spacer>
<div class="main-content overdue">
    <app-data-table [columns]="columns"
                    [showColumnsSelection]="false"
                    [loadPage]="loadPage"
                    [(filters)]="criteria"
                    [filtersComponent]="dataFilter"
                    [loadAtStartup]="false"
                    [loadOnReset]="false"
                    [cleanOnReset]="true"
                    [allowMultiItemSelection]="true"
                    [selectOnRowClick]="false"
                    [noOverflow]="true"
                    (onItemSelection)="selectedDeliveries = $event"
                    (onReset)="resetFilters()"
                    (onLoad)="closeAndApplyFilters()">
        <app-data-filters #dataFilter [fullWidth]="true"
                          [(opened)]="showFilters"
                          [disableSearch]="isSearchDisabled()"
                          [titleKey]="'overdue-process.filters.title'"
                          [showTitle]="true">
            <app-data-filter-group class="main-group"
                                   [flexDirection]="'column'"
                                   [helperKey]="'overdue-process.filters.helper-search'">
                <app-data-filter-group [spaceAuto]="true">
                    <app-data-filter-group [flexDirection]="'column'">
                        <app-data-filter-multi-string-input [labelKey]="'overdue-process.filters.labels.delivery-number'"
                                                            [(model)]="criteria.deliveryNumber"
                                                            (modelChange)="filterMode = FilterMode.CUSTOM">
                        </app-data-filter-multi-string-input>
                        <app-data-buttons>
                            <div class="helper-message" [i18n]="'overdue-process.filters.helper-mode'"></div>
                            <div class="btn btn-i" [ngClass]="{'btn-primary': advancedMode === 'search', 'btn-secondary': advancedMode !== 'search'}"
                                 (click)="switchAdvanceMode('search')">
                                <i class="fa fa-calendar-alt"></i>
                                <span [i18n]="'overdue-process.filters.advanced-search'"></span>
                            </div>
                            <span class="separator" [i18n]="'overdue-process.filters.or'"></span>
                            <div class="btn btn-i" [ngClass]="{'btn-primary': advancedMode === 'actions', 'btn-secondary': advancedMode !== 'actions'}"
                                 (click)="switchAdvanceMode('actions')">
                                <i class="fa fa-bell"></i>
                                <span [i18n]="'overdue-process.filters.advanced-actions'"></span>
                            </div>
                            <spacer [size]="10"></spacer>
                        </app-data-buttons>
                    </app-data-filter-group>
                    <app-data-filter-group [spaceAuto]="true" [flexDirection]="'column'">
                        <app-data-filter-group class="force-space-bottom-15"
                                               [labelKey]="'overdue-process.filters.labels.origin'"
                                               [spaceAuto]="true" style="flex: 1;">
                            <app-data-filter-multi-string-input [labelKey]="'overdue-process.filters.labels.glid'"
                                                                [(model)]="criteria.originGlid">
                            </app-data-filter-multi-string-input>
                            <app-data-filter-select [labelKey]="'overdue-process.filters.labels.country'"
                                                    [options]="countriesOptions"
                                                    [useOptionLabel]="true"
                                                    [(model)]="criteria.originCountryCode"
                                                    [tooltipKey]="'overdue-process.filters.helper-countries'">
                            </app-data-filter-select>
                        </app-data-filter-group>
                        <app-data-filter-group class="force-space-bottom-15"
                                               [labelKey]="'overdue-process.filters.labels.destination'"
                                               [spaceAuto]="true" style="flex: 1;">
                            <app-data-filter-multi-string-input [labelKey]="'overdue-process.filters.labels.glid'"
                                                                [(model)]="criteria.destinationGlid">
                            </app-data-filter-multi-string-input>
                            <app-data-filter-select [labelKey]="'overdue-process.filters.labels.country'"
                                                    [options]="countriesOptions"
                                                    [useOptionLabel]="true"
                                                    [(model)]="criteria.destinationCountryCode"
                                                    [tooltipKey]="'overdue-process.filters.helper-countries'">
                            </app-data-filter-select>
                        </app-data-filter-group>
                    </app-data-filter-group>
                </app-data-filter-group>
                <app-data-filter-group [useAvailableWidth]="true" [fieldset]="true">
                    <app-collapsible class="secondary-group" [arrowElementRef]="filterArrow">
                        <div collapsibleHeader class="flex-row space-between" (click)="filterArrow.triggerToggle()">
                            <label class="collapsible-label" [i18n]="'overdue-process.filters.labels.advanced'"></label>
                            <app-collapsible-arrow #filterArrow [size]="'sm'"></app-collapsible-arrow>
                        </div>
                        <div collapsibleBody class="flex-row space-between collapsible-body">
                            <app-data-filter-group [useAvailableWidth]="true" [ngClass]="{'hidden': advancedMode !== 'search'}" style="flex: 1">
                                <app-data-filter-group *ngTemplateOutlet="advancedSearch"
                                                       [flexDirection]="'column'"
                                                       [spaceAuto]="true">
                                </app-data-filter-group>
                            </app-data-filter-group>
                            <app-data-filter-group [useAvailableWidth]="true" [ngClass]="{'hidden': advancedMode !== 'actions'}" style="flex: 1">
                                <app-data-filter-group *ngTemplateOutlet="advancedActions"
                                                       [flexDirection]="'column'"
                                                       [spaceAuto]="true">
                                </app-data-filter-group>
                            </app-data-filter-group>
                        </div>
                    </app-collapsible>
                </app-data-filter-group>
            </app-data-filter-group>
        </app-data-filters>
        <app-data-buttons class="filter-footer">
            <div class="filters-summary" *ngIf="!showFilters && appliedCriteria">
                <span class="summary-title"><span [i18n]="'overdue-process.filters.applied'"></span>:</span>
                <div class="tags-container">
                    <span class="filter-mode tag" [i18n]="'overdue-process.filters.advanced-'+advancedMode"></span>
                    <span class="tag" *ngIf="appliedCriteria.deliveryNumber && appliedCriteria.deliveryNumber.length > 0"
                          [i18n]="[{target: 'innerHTML', key: 'overdue-process.filters.summary.delivery-number', params: {deliveryNumbers: appliedCriteria.deliveryNumber.join(', ')}}]">
                    </span>
                    <span class="tag" *ngIf="appliedCriteria.shipmentNumber && appliedCriteria.shipmentNumber.length > 0"
                          [i18n]="[{target: 'innerHTML', key: 'overdue-process.filters.summary.shipment-number', params: {shipmentNumbers: appliedCriteria.shipmentNumber.join(', ')}}]">
                    </span>
                    <span class="tag" *ngIf="appliedCriteria.originGlid && appliedCriteria.originGlid.length > 0"
                          [i18n]="[{target: 'innerHTML', key: 'overdue-process.filters.summary.origin-glid', params: {glid: appliedCriteria.originGlid.join(', ').toUpperCase()}}]">
                    </span>
                    <span class="tag" *ngIf="appliedCriteria.originCountryCode"
                          [i18n]="[{target: 'innerHTML', key: 'overdue-process.filters.summary.origin-country', params: {country: appliedCriteria.originCountryCode}}]">
                    </span>
                    <span class="tag" *ngIf="appliedCriteria.destinationGlid  && appliedCriteria.destinationGlid.length > 0"
                          [i18n]="[{target: 'innerHTML', key: 'overdue-process.filters.summary.destination-glid', params: {glid: appliedCriteria.destinationGlid.join(', ').toUpperCase()}}]">
                    </span>
                    <span class="tag" *ngIf="appliedCriteria.destinationCountryCode"
                          [i18n]="[{target: 'innerHTML', key: 'overdue-process.filters.summary.destination-country', params: {country: appliedCriteria.destinationCountryCode}}]">
                    </span>
                    <span class="tag" *ngIf="advancedMode === 'search' && appliedCriteria.originCity"
                          [i18n]="[{target: 'innerHTML', key: 'overdue-process.filters.summary.origin-city', params: {city: appliedCriteria.originCity}}]">
                    </span>
                    <span class="tag" *ngIf="advancedMode === 'search' && appliedCriteria.originPostalCode"
                          [i18n]="[{target: 'innerHTML', key: 'overdue-process.filters.summary.origin-postal-code', params: {postalCode: appliedCriteria.originPostalCode}}]">
                    </span>
                    <span class="tag" *ngIf="advancedMode === 'search' && appliedCriteria.destinationCity"
                          [i18n]="[{target: 'innerHTML', key: 'overdue-process.filters.summary.destination-city', params: {city: appliedCriteria.destinationCity}}]">
                    </span>
                    <span class="tag" *ngIf="advancedMode === 'search' && appliedCriteria.destinationPostalCode"
                          [i18n]="[{target: 'innerHTML', key: 'overdue-process.filters.summary.destination-postal-code', params: {postalCode: appliedCriteria.destinationPostalCode}}]">
                    </span>
                    <span class="tag" *ngIf="advancedMode === 'search' && appliedCriteria.productType && appliedCriteria.productType !== 'ALL'"
                          [i18n]="[{target: 'innerHTML', key: 'overdue-process.filters.summary.product-type', params: {productType: ('overdue-process.filters.labels.product-type.'+appliedCriteria.productType.toLowerCase()) | translate}}]">
                    </span>
                    <span class="tag" *ngIf="advancedMode === 'search' && appliedCriteria.carrierAssigned !== null && appliedCriteria.carrierAssigned !== 'BOTH'">
                        <span *ngIf="appliedCriteria.carrierAssigned" [i18n]="[{target: 'innerHTML', key: 'overdue-process.filters.summary.carrier-assigned', params: {carrierAssigned: ('overdue-process.filters.labels.yes' | translate)}}]"></span>
                        <span *ngIf="!appliedCriteria.carrierAssigned" [i18n]="[{target: 'innerHTML', key: 'overdue-process.filters.summary.carrier-assigned', params: {carrierAssigned: ('overdue-process.filters.labels.no' | translate)}}]"></span>
                    </span>
                    <span class="tag" *ngIf="advancedMode === 'search' && appliedCriteria.collectionType && appliedCriteria.collectionType !== 'BOTH'"
                          [i18n]="[{target: 'innerHTML', key: 'overdue-process.filters.summary.collection-type', params: {collectionType: ('overdue-process.filters.labels.'+appliedCriteria.collectionType.toLowerCase()) | translate}}]">
                    </span>
                    <span class="tag" *ngIf="advancedMode === 'search' && appliedCriteria.pickCompleted !== null && appliedCriteria.pickCompleted !== 'BOTH'">
                        <span *ngIf="appliedCriteria.pickCompleted" [i18n]="'overdue-process.filters.labels.picked'"></span>
                        <span *ngIf="!appliedCriteria.pickCompleted" [i18n]="'overdue-process.filters.labels.not-picked'"></span>
                    </span>
                    <span class="tag" *ngIf="advancedMode === 'search' && appliedCriteria.blocked !== null && appliedCriteria.blocked !== 'BOTH'">
                        <span *ngIf="appliedCriteria.blocked" [i18n]="'overdue-process.filters.labels.blocked'"></span>
                        <span *ngIf="!appliedCriteria.blocked" [i18n]="'overdue-process.filters.labels.not-blocked'"></span>
                    </span>
                    <span class="tag" *ngIf="advancedMode === 'search' && appliedCriteria.sot !== null && appliedCriteria.sot !== 'BOTH'">
                        <span *ngIf="appliedCriteria.sot" [i18n]="[{target: 'innerHTML', key: 'overdue-process.filters.summary.sot', params: {sot: ('overdue-process.filters.labels.yes' | translate)}}]"></span>
                        <span *ngIf="!appliedCriteria.sot" [i18n]="[{target: 'innerHTML', key: 'overdue-process.filters.summary.sot', params: {sot: ('overdue-process.filters.labels.no' | translate)}}]"></span>
                    </span>
                    <span class="tag" *ngIf="advancedMode === 'search' && appliedCriteria.deliveryDateAfter"
                          [i18n]="[{target: 'innerHTML', key: 'overdue-process.filters.summary.delivery-date-after', params: {date: appliedCriteria.deliveryDateAfter | date}}]">
                    </span>
                    <span class="tag" *ngIf="advancedMode === 'search' && appliedCriteria.deliveryDateBefore"
                          [i18n]="[{target: 'innerHTML', key: 'overdue-process.filters.summary.delivery-date-before', params: {date: appliedCriteria.deliveryDateBefore | date}}]">
                    </span>
                    <span class="tag" *ngIf="advancedMode === 'search' && appliedCriteria.deliveryDeadlineAfter"
                          [i18n]="[{target: 'innerHTML', key: 'overdue-process.filters.summary.collection-deadline-after', params: {date: appliedCriteria.deliveryDeadlineAfter | date}}]">
                    </span>
                    <span class="tag" *ngIf="advancedMode === 'search' && appliedCriteria.deliveryDeadlineBefore"
                          [i18n]="[{target: 'innerHTML', key: 'overdue-process.filters.summary.collection-deadline-before', params: {date: appliedCriteria.deliveryDeadlineBefore | date}}]">
                    </span>
                    <span class="tag" *ngIf="advancedMode === 'actions' && appliedCriteria.lastActionAfter"
                          [i18n]="[{target: 'innerHTML', key: 'overdue-process.filters.summary.last-action-after', params: {date: appliedCriteria.lastActionAfter | date}}]">
                    </span>
                    <span class="tag" *ngIf="advancedMode === 'actions' && appliedCriteria.lastActionBefore"
                          [i18n]="[{target: 'innerHTML', key: 'overdue-process.filters.summary.last-action-before', params: {date: appliedCriteria.lastActionBefore | date}}]">
                    </span>
                    <span class="tag" *ngIf="advancedMode === 'actions' && appliedCriteria.lastActionType && appliedCriteria.lastActionType.length > 0"
                          [i18n]="[{target: 'innerHTML', key: 'overdue-process.filters.summary.last-action-type', params: {actionTypes: generateActionTypeLabel()}}]">
                    </span>
                </div>
            </div>

            <div class="counters-btn" *ngIf="advancedMode === 'search'">
                <div class="counter-filter _not-processed" [class._selected]="filterMode === FilterMode.OVERDUE_NOT_PROCESSED"
                     (click)="switchFilterMode(FilterMode.OVERDUE_NOT_PROCESSED)">
                    <span class="counter">{{metricsResult ? metricsResult.overdueAndNotProcessedYet : 0}}</span>&nbsp;
                    <span class="counter-label" [i18n]="'overdue-process.counters.overdue-not-processed'"></span>
                </div>
                <div class="counter-filter _picked" [class._selected]="filterMode === FilterMode.OVERDUE_PICKED" (click)="switchFilterMode(FilterMode.OVERDUE_PICKED)">
                    <span class="counter">{{metricsResult ? metricsResult.overdueAndPicked : 0}}</span>&nbsp;
                    <span class="counter-label" [i18n]="'overdue-process.counters.overdue-picked'"></span>
                </div>
                <div class="counter-filter _due-today" [class._selected]="filterMode === FilterMode.DUE_TODAY" (click)="switchFilterMode(FilterMode.DUE_TODAY)">
                    <span class="counter">{{metricsResult ? metricsResult.dueToday : 0}}</span>&nbsp;
                    <span class="counter-label" [i18n]="'overdue-process.counters.due-today'"></span>
                </div>
                <div class="counter-filter _not-overdue" [class._selected]="filterMode === FilterMode.NOT_OVERDUE" (click)="switchFilterMode(FilterMode.NOT_OVERDUE)">
                    <span class="counter">{{metricsResult ? metricsResult.notOverdue : 0}}</span>&nbsp;
                    <span class="counter-label" [i18n]="'overdue-process.counters.not-overdue'"></span>
                </div>
                <div class="counter-filter _blocked" [class._selected]="filterMode === FilterMode.BLOCKED" (click)="switchFilterMode(FilterMode.BLOCKED)">
                    <span class="counter">{{metricsResult ? metricsResult.blocked : 0}}</span>&nbsp;
                    <span class="counter-label" [i18n]="'overdue-process.counters.blocked'"></span>
                </div>
            </div>

            <div class="actions-buttons">
                <div class="multi-action-buttons">
                    <button class="btn btn-i btn-primary"
                            *ngIf="isGlobalUser"
                            [disabled]="selectedDeliveries.length < 1"
                            (click)="toggleMultipleUpdateRequestModal(selectedDeliveries)"
                            [i18n]="'overdue-process.actions.mass-update'">
                    </button>
                    <button class="btn btn-i btn-primary"
                            *ngIf="!isGlobalUser"
                            [disabled]="selectedDeliveries.length < 1"
                            (click)="toggleMultipleEditModal(selectedDeliveries)"
                            [i18n]="'overdue-process.action-modal.mass-edit.button-label'">
                    </button>
                    <div class="checkbox">
                        <label>
                            <input type="checkbox"
                                   [disabled]="overdueTable.items.length === 0"
                                   [checked]="!isMoreDeliveriesSelectable() && overdueTable.items.length !== 0"
                                   (click)="toggleSelectOrDeselectAll()">
                            <i class="fa checkbox-icon white-bg"></i>
                            <span [i18n]="!isMoreDeliveriesSelectable() && overdueTable.items.length !== 0 ?
                                  'overdue-process.actions.deselect-all':'overdue-process.actions.select-all'">
                            </span>
                        </label>
                    </div>
                </div>
                <button class="btn btn-i btn-primary"
                        [disabled]="!criteria.originGlid &&
                                    !criteria.destinationGlid &&
                                    !criteria.destinationCountryCode"
                        (click)="exportDeliveries()"
                        [i18n]="'overdue-process.actions.export'">
                </button>
            </div>
        </app-data-buttons>
    </app-data-table>
</div>

<ng-template #advancedSearch>
    <app-data-filter-group [spaceAuto]="true">
        <app-data-filter-group [flexDirection]="'column'">
            <app-data-filter-multi-string-input class="space-bottom-20"
                                                [labelKey]="'overdue-process.filters.labels.shipment-number'"
                                                [(model)]="criteria.shipmentNumber"
                                                (modelChange)="filterMode = FilterMode.CUSTOM">
            </app-data-filter-multi-string-input>

            <app-data-filter-group class="space-bottom-20"
                                  [spaceAuto]="true"
                                  [labelKey]="'overdue-process.filters.labels.origin'">
                <app-data-filter-input [labelKey]="'overdue-process.filters.labels.city'"
                                       [(model)]="criteria.originCity">
                </app-data-filter-input>
                <app-data-filter-input [labelKey]="'overdue-process.filters.labels.postal-code'"
                                       [(model)]="criteria.originPostalCode">
                </app-data-filter-input>
            </app-data-filter-group>

            <app-data-filter-group class="space-bottom-20"
                                  [spaceAuto]="true"
                                  [labelKey]="'overdue-process.filters.labels.destination'">
                <app-data-filter-input [labelKey]="'overdue-process.filters.labels.city'"
                                       [(model)]="criteria.destinationCity">
                </app-data-filter-input>
                <app-data-filter-input [labelKey]="'overdue-process.filters.labels.postal-code'"
                                       [(model)]="criteria.destinationPostalCode">
                </app-data-filter-input>
            </app-data-filter-group>
        </app-data-filter-group>

        <app-data-filter-group class="space-bottom-20" style="margin-left: 24px;"
                               [flexDirection]="'column'"
                               [spaceAuto]="true"
                               [useAvailableWidth]="true">
            <app-data-filter-group [spaceAuto]="true" class="space-bottom-20">
                <app-data-filter-select [labelKey]="'overdue-process.filters.labels.product-type.title'"
                                        [(model)]="criteria.productType"
                                        [options]="productTypeOptions">
                </app-data-filter-select>
                <app-data-filter-select [labelKey]="'overdue-process.filters.labels.carrier'"
                                        [(model)]="criteria.carrierAssigned"
                                        [options]="carrierOptions">
                </app-data-filter-select>
            </app-data-filter-group>

            <app-data-filter-group [spaceAuto]="true" class="space-bottom-20">
                <app-data-filter-select [labelKey]="'overdue-process.filters.labels.type'"
                                        [(model)]="criteria.collectionType"
                                        [options]="typeOptions">
                </app-data-filter-select>
                <app-data-filter-select [labelKey]="'overdue-process.filters.labels.picked'"
                                        [(model)]="criteria.pickCompleted"
                                        (modelChange)="filterMode = FilterMode.CUSTOM"
                                        [options]="pickedOptions">
                </app-data-filter-select>
                <app-data-filter-select [labelKey]="'overdue-process.filters.labels.blocked'"
                                        [(model)]="criteria.blocked"
                                        (modelChange)="filterMode = FilterMode.CUSTOM"
                                        [options]="blockedOptions">
                </app-data-filter-select>
                <app-data-filter-select [labelKey]="'overdue-process.filters.labels.sot'"
                                        [(model)]="criteria.sot"
                                        [options]="sotOptions">
                </app-data-filter-select>
            </app-data-filter-group>

            <app-data-filter-group [spaceAuto]="true">
                <app-data-filter-group [labelKey]="'overdue-process.filters.labels.delivery-date'"
                                       style="flex: 1; min-width: 350px;">
                    <app-data-filter-date [labelKey]="'overdue-process.filters.labels.between'"
                                          [(model)]="criteria.deliveryDateAfter">
                    </app-data-filter-date>
                    <app-data-filter-date [labelKey]="'overdue-process.filters.labels.and'"
                                          [(model)]="criteria.deliveryDateBefore">
                    </app-data-filter-date>
                </app-data-filter-group>

                <app-data-filter-group  [labelKey]="'overdue-process.filters.labels.delivery-deadline'"
                                        style="flex: 1; min-width: 350px;">
                    <app-data-filter-date [labelKey]="'overdue-process.filters.labels.between'"
                                          [(model)]="criteria.deliveryDeadlineAfter"
                                          (modelChange)="filterMode = FilterMode.CUSTOM">
                    </app-data-filter-date>
                    <app-data-filter-date [labelKey]="'overdue-process.filters.labels.and'"
                                          [(model)]="criteria.deliveryDeadlineBefore"
                                          (modelChange)="filterMode = FilterMode.CUSTOM">
                    </app-data-filter-date>
                </app-data-filter-group>
            </app-data-filter-group>
        </app-data-filter-group>
    </app-data-filter-group>
</ng-template>

<ng-template #advancedActions>
    <app-data-filter-group [spaceAuto]="true" class="space-bottom-20">
        <app-data-filter-group [labelKey]="'overdue-process.filters.action.date'">
            <app-data-filter-date [labelKey]="'overdue-process.filters.labels.between'"
                                  [(model)]="lastActionAfter">
            </app-data-filter-date>
            <app-data-filter-date [labelKey]="'overdue-process.filters.labels.and'"
                                  [(model)]="lastActionBefore">
            </app-data-filter-date>
        </app-data-filter-group>

        <app-data-filter-group [labelKey]="'overdue-process.filters.action.type'">
            <app-data-filter-checkbox [(model)]="lastActionType" [options]="lastActionTypeOptions"
            style="align-items: center; display: flex; height: 6px;">
            </app-data-filter-checkbox>
        </app-data-filter-group>
    </app-data-filter-group>
</ng-template>

<ng-template #numberColumn
             let-selectItem="selectItem"
             let-deliveryNumber="deliveryNumber"
             let-indicator="indicator"
             let-shipment="shipment"
             let-type="type"
             let-selected="selected">
    <div class="id-numbers" [ngClass]="type">
        <div class="checkbox"
             [style.visibility]="shouldDisplayCheckbox(indicator) ? 'visible' : 'hidden'">
            <label>
                <input type="checkbox"
                       [ngModel]="selected"
                       (ngModelChange)="selectItem()">
                <i class="fa checkbox-icon"></i>
            </label>
        </div>
        <div>
            <a class="delivery-number cmaweb-link" [href]="link.goToLoadManagementForDelivery(deliveryNumber)" target="_blank">{{deliveryNumber}}</a>
            <a class="load-number cmaweb-link" [href]="link.goToLoadManagementForLoad(shipment.loadNumber)" target="_blank">{{shipment.loadNumber}}</a>
        </div>
    </div>
</ng-template>

<ng-template #priorityColumn let-priority="deliveryPriority">
    {{priority}}
</ng-template>

<ng-template #carrierColumn let-carrier="carrier">
    {{carrier.name}}
</ng-template>

<ng-template #originColumn let-origin="origin">
    <span>
        <span>{{origin.name}},</span>&nbsp;
        <span><span>{{origin.address.address1}}</span><span>{{origin.address.address2}}</span><span>{{origin.address.address3}}</span>,</span>&nbsp;
        <span><span>{{origin.address.zip}}</span><span>{{origin.address.city}}</span>,</span>&nbsp;
        <span>{{origin.address.country}}</span>
    </span>
</ng-template>

<ng-template #destinationColumn let-destination="destination">
    <span>
        <span>{{destination.name}},</span>&nbsp;
        <span><span>{{destination.address.address1}}</span><span>{{destination.address.address2}}</span><span>{{destination.address.address3}}</span>,</span>&nbsp;
        <span><span>{{destination.address.zip}}</span><span>{{destination.address.city}}</span>,</span>&nbsp;
        <span>{{destination.address.country}}</span>
    </span>
</ng-template>

<ng-template #deliveryDateColumn let-deliveryDate="deliveryDate">
    {{deliveryDate | date : 'dd/MM/yyyy'}}
</ng-template>

<ng-template #GIDateColumn let-GIDate="deliveryGiDate">
    {{GIDate | date : 'dd/MM/yyyy'}}
</ng-template>

<ng-template #deadlineColumn let-deadline="deliveryDeadline">
    {{deadline | date : 'dd/MM/yyyy'}}
</ng-template>

<ng-template #pickedColumn let-picked="picked">
    <i class="fas" [ngClass]="{'fa-check-circle': picked, 'fa-times-circle': !picked}"></i>
</ng-template>

<ng-template #sotColumn let-sot="sot" let-sotPeriodicity="sotPeriodicity">
    <div class="sot">
        <div *ngIf="!sot">-</div>
        <div *ngIf="sot" class="sot-periodicity">&nbsp;{{sotPeriodicity}}</div>
    </div>
</ng-template>

<ng-template #productsColumn let-lines="lines" let-products="products" let-id="deliveryNumber">
    <div class="products">
        <span>{{products}}</span>&nbsp;<button class="products-infos fa fa-info-circle" (click)="toggleProductInfo(id)"></button>
        <div [id]="'product-detail-'+id" class="product-detail" tabIndex="0" style="display: none" (blur)="toggleProductInfo(id, true)">
            <div class="product-title" [i18n]="'overdue-process.table.products'"></div>
            <ng-container *ngFor="let line of lines">
                <div class="product-detail-item">
                    {{line.productCode}} - {{line.productDescription}} <span class="product-detail-item-quantity">{{line.quantity}}</span>
                </div>
            </ng-container>
        </div>
    </div>
</ng-template>

<ng-template #overdueColumn
             let-overdue="overdue"
             let-action="actionRequired"
             let-type="type"
             let-item="item"
             let-indicator="indicator">
    <div class="overdue-container">
        <span class="overdue-container-day" [ngClass]="type">{{overdue}}</span>
        <div class="overdue-container-action-list">
            <button class="overdue-container-action action-ask-update"
                    *ngIf="isGlobalUser && indicator !== OverdueDeliveryIndicator.WARNING"
                    (click)="toggleSingleUpdateRequestModal(item)">
                <i class="fas fa-comment"></i>
                <span class="overdue-container-action-state" *ngIf="action"><i class="fa fa-warning"></i></span>
            </button>

            <button class="overdue-container-action action-edit"
                    [class.rounded]="!isGlobalUser || indicator === OverdueDeliveryIndicator.WARNING"
                    (click)="toggleActionModal(item)">
                <i class="fas fa-pencil-alt"></i>
                <i class="indicator fas fa-warning" *ngIf="indicator === OverdueDeliveryIndicator.WARNING"></i>
                <i class="indicator fas fa-hourglass-half" *ngIf="indicator === OverdueDeliveryIndicator.HOURGLASS"></i>
                <i class="indicator fas fa-check" *ngIf="indicator === OverdueDeliveryIndicator.CHECK"></i>
                <i class="indicator fas fa-times" *ngIf="indicator === OverdueDeliveryIndicator.CROSS"></i>
            </button>
        </div>
    </div>
</ng-template>

<ng-template #reviewModal let-history="history" let-lastAction="lastAction">
    <div class="popupActions">
        <ng-container *ngTemplateOutlet="historyTpl;context:{histories:history}"></ng-container>
        <div class="changes">
            <div class="title" [i18n]="'overdue-process.action-modal.review.title'"></div>

            <ng-container *ngIf="lastAction">
                <div class="reason">
                    <span class="_large" [i18n]="'overdue-process.action-modal.changes.reason'"></span>:
                    <span [i18n]="'overdue-process.action-modal.actions.reasons.'+lastAction.type.toLowerCase()"></span>
                </div>
                <div class="changes-list">
                    <div class="changes-list-group">
                        <div class="change-container" [ngClass]="{'approved': approved, 'rejected': approved === false, 'neutral': approved === null}">
                            <div class="change-group">
                                <ng-container *ngIf="lastAction.type === OverdueLoadActionType.HOLIDAY || lastAction.type === OverdueLoadActionType.OTHER">
                                    <div>
                                        <label><span [i18n]="'overdue-process.action-modal.labels.delivery-date'"></span>:</label>
                                        <div class="helper" [i18n]="'overdue-process.action-modal.changes.delivery-date-helper'"></div>
                                        <div class="change">
                                            <div class="group">
                                                <span><span [i18n]="'overdue-process.action-modal.changes.actual-delivery-date'"></span>:</span>
                                                <span class="blue">{{lastAction.previousDeliveryDate | date: 'dd/MM/yyyy'}}</span>
                                            </div>
                                            <div class="group">
                                                <span><span [i18n]="'overdue-process.action-modal.changes.proposed-delivery-date'"></span>:</span>
                                                <span class="blue">{{lastAction.newDeliveryDate | date: 'dd/MM/yyyy'}}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <label><span [i18n]="'overdue-process.action-modal.labels.GI-date'"></span>:</label>
                                        <div class="helper" [i18n]="'overdue-process.action-modal.changes.gi-date-helper'"></div>
                                        <div class="change">
                                            <div class="group">
                                                <span><span [i18n]="'overdue-process.action-modal.changes.actual-GI-date'"></span>:</span>
                                                <span class="blue">{{lastAction.previousGiDate | date: 'dd/MM/yyyy'}}</span>
                                            </div>
                                            <div class="group">
                                                <span><span [i18n]="'overdue-process.action-modal.changes.proposed-GI-date'"></span>:</span>
                                                <span class="blue">{{lastAction.newGiDate | date: 'dd/MM/yyyy'}}</span>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>
                                <div *ngIf="lastAction.haulierCommentary">
                                    <label class="control-label" [i18n]="'overdue-process.action-modal.labels.comment'"></label>
                                    <div class="group">
                                        <textarea class="form-control m-b" [(ngModel)]="lastAction.haulierCommentary" readonly></textarea>
                                    </div>
                                </div>
                            </div>
                            <div class="change no-justify" *ngIf="lastAction.duplicatedDeliveryNumber">
                                <div class="group">
                                    <span class="_large"><span [i18n]="'overdue-process.action-modal.labels.duplicated'"></span>:</span>
                                    <span class="delivery-number blue">{{lastAction.duplicatedDeliveryNumber}}</span>
                                </div>
                            </div>
                            <div *ngIf="lastAction.type === OverdueLoadActionType.DUPLICATE || lastAction.type === OverdueLoadActionType.COMPLETE"
                                 [i18n]="'overdue-process.action-modal.history.POD-in-TMS'">
                            </div>
                        </div>
                    </div>


                    <div class="form-group">
                        <ng-container *ngIf="approved === false">
                            <label class="control-label _small" [i18n]="'overdue-process.action-modal.changes.rejection-reason'"></label>
                            <textarea class="form-control m-b" [(ngModel)]="commentary"></textarea>
                        </ng-container>
                        <div class="actions">
                            <div>
                                <button class="reject" (click)="approved = false" [i18n]="'overdue-process.action-modal.changes.reject'"></button>
                            </div>
                            <div>
                                <button class="approve" (click)="approved = true" [i18n]="'overdue-process.action-modal.changes.approved'"></button>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</ng-template>

<ng-template #updateModal let-history="history">
    <div class="popupActions">
        <ng-container *ngTemplateOutlet="historyTpl;context:{histories:history}"></ng-container>
        <div class="changes">
            <div class="title" [i18n]="'overdue-process.action-modal.update.label'"></div>

            <textarea class="form-control m-b" [(ngModel)]="commentary" [i18n]="[{target: 'attribute:placeholder', key: 'overdue-process.action-modal.update.placeholder'}]" ></textarea>
        </div>
    </div>
</ng-template>

<ng-template #updateMultiModal
             let-historiesByDeliveryNumber="historiesByDeliveryNumber"
             let-deliveriesNumber="deliveriesNumber">
    <div class="popupActions">
        <ng-container *ngTemplateOutlet="historyTpl;context:{multiple: true, historiesByDeliveryNumber:historiesByDeliveryNumber, deliveriesNumber: deliveriesNumber}"></ng-container>
        <div class="changes">
            <div class="title" [i18n]="'overdue-process.action-modal.mass-update.subtitle'"></div>
            <p [i18n]="'overdue-process.action-modal.mass-update.label'"></p>
            <textarea class="form-control m-b"
                      [(ngModel)]="commentary"
                      [i18n]="[{target: 'attribute:placeholder', key: 'overdue-process.action-modal.mass-update.placeholder'}]">
            </textarea>
        </div>
    </div>
</ng-template>

<ng-template #editModal
             let-delivery="delivery"
             let-history="history"
             let-lastAction="lastAction"
             let-today="today"
             let-picked="picked">
    <div class="popupActions">
        <ng-container *ngTemplateOutlet="historyTpl;context:{histories:history}"></ng-container>

        <div class="changes">
            <div class="title" [i18n]="'overdue-process.action-modal.changes.title'"></div>

            <ng-container *ngIf="!lastAction">
                <div class="helper" [i18n]="'overdue-process.action-modal.changes.reason-helper'"></div>
                <ng-select [items]="actionTypes" [(ngModel)]="actionType" bindValue="value"></ng-select>
                <spacer size="16"></spacer>

                <div class="helper" *ngIf="actionType === OverdueLoadActionType.OTHER">
                    <div [i18n]="'overdue-process.action-modal.changes.other-helper'"></div>
                    <div [i18n]="'overdue-process.action-modal.changes.other-sub-helper'"></div>
                </div>
                <div class="helper main" *ngIf="actionType"><span [i18n]="'overdue-process.action-modal.changes.helper'"></span>:</div>

                <ng-container *ngIf="actionType === OverdueLoadActionType.HOLIDAY || actionType === OverdueLoadActionType.OTHER">

                    <div class="value-wrapper">
                        <label [i18n]="'overdue-process.action-modal.labels.delivery-date'"></label>
                        <input class="form-control"
                               [class.falsely-disabled]="!picked && !deliveryDateDisabled"
                               [disabled]="picked || deliveryDateDisabled"
                               [dpDayPicker]="datePickerConfigDeliveryDate"
                               [theme]="'date-time-picker'"
                               [(ngModel)]="proposedDeliveryDate"
                               (ngModelChange)="checkActionModalData(picked ? $event : today)">
                    </div>
                    <div class="helper" [i18n]="'overdue-process.action-modal.changes.delivery-date-helper'"></div>

                    <div class="value-wrapper">
                        <label [i18n]="'overdue-process.action-modal.labels.GI-date'"></label>
                        <input class="form-control"
                               [class.falsely-disabled]="!giDateDisabled"
                               [disabled] = "giDateDisabled"
                               [dpDayPicker]="datePickerConfigGIDate"
                               [theme]="'date-time-picker'"
                               [(ngModel)]="proposedGiDate"
                               (ngModelChange)="checkActionModalData(today)">
                    </div>

                    <!-- HELPERS -->

                    <div class="helper" [i18n]="'overdue-process.action-modal.changes.gi-date-helper'"></div>
                    <ng-container *ngIf="actionType === OverdueLoadActionType.OTHER">
                        <spacer size="16"></spacer>
                        <label [i18n]="'overdue-process.action-modal.labels.comment'"></label><br>
                        <textarea class="commentary" [(ngModel)]="commentary"></textarea>
                    </ng-container>

                    <!-- ERRORS -->

                    <div class="error-case" *ngIf="!deliveryDateDisabled && deliveryDateError">
                        <span class="fa fa-warning"></span>
                        <div>
                            <div [i18n]="'overdue-process.action-modal.changes.errors.delivery-date'"></div>
                            <div [i18n]="'overdue-process.action-modal.changes.errors.date-helper'"></div>
                        </div>
                    </div>
                    <div class="error-case" *ngIf="!giDateDisabled && giDateError">
                        <span class="fa fa-warning"></span>
                        <div>
                            <div [i18n]="'overdue-process.action-modal.changes.errors.gi-date'"></div>
                            <div [i18n]="'overdue-process.action-modal.changes.errors.date-helper'"></div>
                        </div>
                    </div>
                    <div class="error-case" *ngIf="deliveryDateDisabled && deliveryTooLateError">
                        <span class="fa fa-warning"></span>
                        <div>
                            <div [i18n]="'overdue-process.action-modal.changes.errors.delivery-date-too-late'"></div>
                        </div>
                    </div>

                    <div class="error-case" *ngIf="giDateDisabled && giTooLateError">
                        <span class="fa fa-warning"></span>
                        <div>
                            <div [i18n]="'overdue-process.action-modal.changes.errors.gi-date-too-late'"></div>
                        </div>
                    </div>

                </ng-container>
                <ng-container *ngIf="actionType === OverdueLoadActionType.PROBLEM">
                    <spacer size="16"></spacer>
                    <label [i18n]="'overdue-process.action-modal.labels.comment'"></label><br>
                    <textarea class="commentary" [(ngModel)]="commentary"></textarea>
                    <div class="error-case" *ngIf="commentaryError">
                        <span class="fa fa-warning"></span>
                        <div>
                            <div [i18n]="'overdue-process.action-modal.changes.errors.commentary'"></div>
                        </div>
                    </div>
                </ng-container>
                <ng-container *ngIf="actionType === OverdueLoadActionType.DUPLICATE">
                    <div class="value-wrapper">
                        <label [i18n]="'overdue-process.action-modal.labels.duplicated'"></label>
                        <input class="form-control" type="text" maxlength="10" [(ngModel)]="duplicatedDeliveryNumber" (ngModelChange)="checkActionModalData(null)">
                    </div>
                    <div><span [i18n]="'overdue-process.action-modal.labels.POD'"></span>: <span [i18n]="'overdue-process.action-modal.changes.duplicate-POD'"></span></div>
                    <div class="POD-input">
                        <label><input type="radio" name="validPOD" [value]="true" [(ngModel)]="validPODinTMS" (ngModelChange)="checkActionModalData(null)"><span [i18n]="'overdue-process.action-modal.changes.yes'"></span></label>
                        <label><input type="radio" name="validPOD" [value]="false" [(ngModel)]="validPODinTMS" (ngModelChange)="checkActionModalData(null)"><span [i18n]="'overdue-process.action-modal.changes.no'"></span></label>
                    </div>
                    <div class="error-case" *ngIf="duplicatedDeliveryNumberError">
                        <span class="fa fa-warning"></span>
                        <div [i18n]="'overdue-process.action-modal.changes.errors.duplicate-number'"></div>
                    </div>
                    <div class="error-case" *ngIf="validPODinTMSError">
                        <span class="fa fa-warning"></span>
                        <div [i18n]="'overdue-process.action-modal.changes.errors.duplicate-POD'"></div>
                    </div>
                </ng-container>
                <ng-container *ngIf="actionType === OverdueLoadActionType.COMPLETE">
                    <div><span [i18n]="'overdue-process.action-modal.labels.POD'"></span>: <span [i18n]="[{target: 'innerHTML', key: 'overdue-process.action-modal.changes.@completed-POD', params: {shipmentNumber: delivery}}]"></span></div>
                    <div class="POD-input">
                        <label><input type="radio" name="validPOD" [value]="true" [(ngModel)]="validPODinTMS" (ngModelChange)="checkActionModalData(null)"><span [i18n]="'overdue-process.action-modal.changes.yes'"></span></label>
                        <label><input type="radio" name="validPOD" [value]="false" [(ngModel)]="validPODinTMS" (ngModelChange)="checkActionModalData(null)"><span [i18n]="'overdue-process.action-modal.changes.no'"></span></label>
                    </div>
                    <div class="error-case" *ngIf="validPODinTMSError">
                        <span class="fa fa-warning"></span>
                        <div [i18n]="'overdue-process.action-modal.changes.errors.complete-POD'"></div>
                    </div>
                </ng-container>
            </ng-container>
        </div>
    </div>
</ng-template>

<ng-template #editMultiModal
             let-historiesByDeliveryNumber="historiesByDeliveryNumber"
             let-deliveriesNumber="deliveriesNumber"
             let-oneIsPicked="oneIsPicked"
             let-today="today">
    <div class="popupActions">
        <ng-container *ngTemplateOutlet="historyTpl;context:{multiple: true, historiesByDeliveryNumber: historiesByDeliveryNumber, deliveriesNumber: deliveriesNumber}"></ng-container>

        <div class="changes">
            <div class="title" [i18n]="'overdue-process.action-modal.mass-edit.sub-title'"></div>

            <div class="helper" [i18n]="'overdue-process.action-modal.mass-edit.reason-helper'"></div>
            <ng-select [items]="multiActionTypes" [(ngModel)]="actionType" bindValue="value"></ng-select>
            <spacer size="16"></spacer>

            <div class="helper main" *ngIf="actionType">
                <p class="font-bold" [i18n]="'overdue-process.action-modal.mass-edit.helper'"></p>
                <p [i18n]="'overdue-process.action-modal.mass-edit.sub-helper'"></p>
            </div>

            <ng-container *ngIf="actionType === OverdueLoadActionType.HOLIDAY || actionType === OverdueLoadActionType.OTHER">

                <div class="value-wrapper">
                    <label class="font-bold" [i18n]="'overdue-process.action-modal.labels.delivery-date'"></label>
                    <input class="form-control"
                           [class.falsely-disabled]="!deliveryDateDisabled"
                           [disabled]="deliveryDateDisabled"
                           [dpDayPicker]="datePickerConfigDeliveryDate"
                           [theme]="'date-time-picker'"
                           [(ngModel)]="proposedDeliveryDate"
                           (ngModelChange)="checkActionModalData(today)">
                </div>
                <app-callout
                    *ngIf="oneIsPicked"
                    [i18nkey]="'overdue-process.action-modal.changes.errors.multi-one-is-picked'"
                    [faIcon]="'fa fa-info-circle'"
                ></app-callout>

                <div class="helper" [i18n]="'overdue-process.action-modal.mass-edit.delivery-date-helper'"></div>

                <div class="value-wrapper">
                    <label class="font-bold" [i18n]="'overdue-process.action-modal.labels.GI-date'"></label>
                    <input class="form-control"
                           [class.falsely-disabled]="!giDateDisabled"
                           [disabled]="giDateDisabled"
                           [dpDayPicker]="datePickerConfigGIDate"
                           [theme]="'date-time-picker'"
                           [(ngModel)]="proposedGiDate"
                           (ngModelChange)="checkActionModalData(today)"
                    >
                </div>

                <!-- HELPERS -->

                <div class="helper" [i18n]="'overdue-process.action-modal.mass-edit.gi-date-helper'"></div>

                <ng-container *ngIf="actionType === OverdueLoadActionType.OTHER">
                    <spacer size="16"></spacer>
                    <label class="font-bold" [i18n]="'overdue-process.action-modal.labels.comment'"></label><br>
                    <textarea class="commentary" [(ngModel)]="commentary"></textarea>
                </ng-container>

                <!-- ERRORS -->

                <div class="error-case" *ngIf="!deliveryDateDisabled && deliveryDateError">
                    <span class="fa fa-warning"></span>
                    <div>
                        <div [i18n]="'overdue-process.action-modal.changes.errors.delivery-date'"></div>
                        <div [i18n]="'overdue-process.action-modal.changes.errors.date-helper'"></div>
                    </div>
                </div>

                <div class="error-case" *ngIf="!giDateDisabled && giDateError">
                    <span class="fa fa-warning"></span>
                    <div>
                        <div [i18n]="'overdue-process.action-modal.changes.errors.gi-date'"></div>
                        <div [i18n]="'overdue-process.action-modal.changes.errors.date-helper'"></div>
                    </div>
                </div>

                <div class="error-case" *ngIf="deliveryDateDisabled && deliveryTooLateError">
                    <span class="fa fa-warning"></span>
                    <div>
                        <div [i18n]="'overdue-process.action-modal.changes.errors.delivery-date-too-late'"></div>
                    </div>
                </div>

                <div class="error-case" *ngIf="giDateDisabled && giTooLateError">
                    <span class="fa fa-warning"></span>
                    <div>
                        <div [i18n]="'overdue-process.action-modal.changes.errors.gi-date-too-late'"></div>
                    </div>
                </div>

            </ng-container>
            <ng-container *ngIf="actionType === OverdueLoadActionType.COMPLETE">
                <div><span [i18n]="'overdue-process.action-modal.labels.POD'"></span>: <span [i18n]="'overdue-process.action-modal.mass-edit.completed-POD'"></span></div>
                <div class="POD-input">
                    <label><input type="radio" name="validPOD" [value]="true" [(ngModel)]="validPODinTMS" (ngModelChange)="checkActionModalData(null)"><span [i18n]="'overdue-process.action-modal.changes.yes'"></span></label>
                    <label><input type="radio" name="validPOD" [value]="false" [(ngModel)]="validPODinTMS" (ngModelChange)="checkActionModalData(null)"><span [i18n]="'overdue-process.action-modal.changes.no'"></span></label>
                </div>
                <div class="error-case" *ngIf="validPODinTMSError">
                    <span class="fa fa-warning"></span>
                    <div [i18n]="'overdue-process.action-modal.changes.errors.complete-POD'"></div>
                </div>
            </ng-container>
        </div>
    </div>
</ng-template>

<ng-template #historyTpl
             let-histories="histories"
             let-multiple="multiple"
             let-deliveriesNumber="deliveriesNumber"
             let-historiesByDeliveryNumber="historiesByDeliveryNumber">
    <div class="history">
        <div class="title" [i18n]="'overdue-process.action-modal.history.title'"></div>

        <select *ngIf="multiple" [(ngModel)]="multiActionModalSelectedDelivery">
            <option *ngFor="let deliveryNumber of deliveriesNumber" [ngValue]="deliveryNumber">{{deliveryNumber}}</option>
        </select>

        <spacer size="16"></spacer>
        <div class="history-list">
            <div class="history-list-detail" [class._awaitingState]="history.type !== OverdueLoadActionType.INFO_REQUEST && history.status === OverdueLoadActionStatus.PENDING"
                                             [class._validated]="history.status === OverdueLoadActionStatus.APPROVED"
                                             [class._rejected]="history.status === OverdueLoadActionStatus.REJECTED || (history.type === OverdueLoadActionType.INFO_REQUEST && history.status === OverdueLoadActionStatus.PENDING)"
                 *ngFor="let history of (multiple ? historiesByDeliveryNumber[multiActionModalSelectedDelivery] : histories)">
                <div class="history-list-date">
                    <div>
                        {{history.date | date : 'dd/MM/yyyy - HH:mma'}}
                        <div class="awaiting-validation" *ngIf="history.status === OverdueLoadActionStatus.PENDING && history.type !== OverdueLoadActionType.INFO_REQUEST">
                            <i class="fa fa-warning"></i>
                            <div *ngIf="history.type !== OverdueLoadActionType.INFO_REQUEST" [i18n]="'overdue-process.action-modal.history.awaiting-validation'"></div>
                        </div>
                        <div class="validated" *ngIf="history.status === OverdueLoadActionStatus.APPROVED">
                            <i class="fa fa-check-circle"></i>
                            <div *ngIf="history.type !== OverdueLoadActionType.INFO_REQUEST" [i18n]="'overdue-process.action-modal.history.approved'"></div>
                            <div *ngIf="history.type === OverdueLoadActionType.INFO_REQUEST" [i18n]="'overdue-process.action-modal.history.info-given'"></div>
                        </div>
                        <div class="rejected" *ngIf="history.status === OverdueLoadActionStatus.REJECTED ||
                                                    (history.type === OverdueLoadActionType.INFO_REQUEST && history.status === OverdueLoadActionStatus.PENDING)">
                            <i class="fa fa-times-circle" *ngIf="history.type !== OverdueLoadActionType.INFO_REQUEST"></i>
                            <i class="fa fa-warning" *ngIf="history.type === OverdueLoadActionType.INFO_REQUEST"></i>
                            <div *ngIf="history.type !== OverdueLoadActionType.INFO_REQUEST" [i18n]="'overdue-process.action-modal.history.rejected'"></div>
                            <div *ngIf="history.type === OverdueLoadActionType.INFO_REQUEST" [i18n]="'overdue-process.action-modal.history.awaiting-action'"></div>
                        </div>
                    </div>
                </div>
                <div class="history-global-info">
                    <div [i18n]="'overdue-process.action-modal.history.'+history.type.toLowerCase()"
                         *ngIf="history.type === OverdueLoadActionType.HOLIDAY ||
                                history.type === OverdueLoadActionType.OTHER ||
                                history.type === OverdueLoadActionType.DUPLICATE ||
                                history.type === OverdueLoadActionType.INFO_REQUEST ||
                                history.type === OverdueLoadActionType.COMPLETE ||
                                history.type === OverdueLoadActionType.PROBLEM">
                    </div>
                    <div [i18n]="'overdue-process.action-modal.history.'+history.status.toLowerCase()+'-by'"
                         *ngIf="history.type === OverdueLoadActionType.OTHER_REVIEW ||
                                history.type === OverdueLoadActionType.HOLIDAY_REVIEW ||
                                history.type === OverdueLoadActionType.COMPLETE_REVIEW ||
                                history.type === OverdueLoadActionType.DUPLICATE_REVIEW ||
                                history.type === OverdueLoadActionType.PROBLEM_REVIEW">
                    </div>
                    <span [i18n]="'overdue-process.action-modal.changes.by'"></span>&nbsp;
                    <span class="history-perpetrator">{{history.user}}</span>
                    <div class="history-fields">
                        <ng-container *ngIf="history.type === OverdueLoadActionType.HOLIDAY || history.type === OverdueLoadActionType.OTHER">
                            <div class="modification-container">
                                <div class="modification-label">
                                    <span [i18n]="'overdue-process.action-modal.labels.delivery-date'"></span>&nbsp;
                                </div>
                                <div class="modification-content">
                                    <div>
                                        <span [i18n]="'overdue-process.action-modal.changes.from'"></span>&nbsp;
                                        <span class="blue">{{history.previousDeliveryDate | date : 'dd/MM/yyyy'}}</span>
                                    </div>
                                    <div>
                                        <span [i18n]="'overdue-process.action-modal.changes.to'"></span>&nbsp;
                                        <span class="blue">{{history.newDeliveryDate | date : 'dd/MM/yyyy'}}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="modification-container">
                                <div class="modification-label">
                                    <span [i18n]="'overdue-process.action-modal.labels.GI-date'"></span>&nbsp;
                                </div>
                                <div class="modification-content">
                                    <div>
                                        <span [i18n]="'overdue-process.action-modal.changes.from'"></span>&nbsp;
                                        <span class="blue">{{history.previousGiDate | date : 'dd/MM/yyyy'}}</span>
                                    </div>
                                    <div>
                                        <span [i18n]="'overdue-process.action-modal.changes.to'"></span>&nbsp;
                                        <span class="blue">{{history.newGiDate | date : 'dd/MM/yyyy'}}</span>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="history.haulierCommentary">
                            <div [i18n]="'overdue-process.action-modal.history.comment'"></div>
                            <div>{{history.haulierCommentary}}</div>
                        </ng-container>
                        <ng-container *ngIf="history.type === OverdueLoadActionType.DUPLICATE || history.type === OverdueLoadActionType.COMPLETE">
                            <ng-container *ngIf="history.duplicatedDeliveryNumber">
                                <span [i18n]="'overdue-process.action-modal.history.duplicate-of'"></span>&nbsp;
                                <span class="blue">{{history.duplicatedDeliveryNumber}}</span>
                            </ng-container>
                            <div [i18n]="'overdue-process.action-modal.history.POD-in-TMS'"></div>
                        </ng-container>
                        <ng-container *ngIf="history.type === OverdueLoadActionType.INFO_REQUEST ||
                                             history.type === OverdueLoadActionType.HOLIDAY_REVIEW ||
                                             history.type === OverdueLoadActionType.OTHER_REVIEW ||
                                             history.type === OverdueLoadActionType.COMPLETE_REVIEW ||
                                             history.type === OverdueLoadActionType.DUPLICATE_REVIEW ||
                                             history.type === OverdueLoadActionType.PROBLEM_REVIEW">
                            <ng-container *ngIf="history.chepCommentary">
                                <span><span [i18n]="'overdue-process.action-modal.history.comment'"></span>:</span>
                                <div>{{history.chepCommentary}}</div>
                            </ng-container>
                        </ng-container>
                    </div>
                </div>
            </div>
            <div class="no-history" *ngIf="!histories || histories.length === 0"
                 [i18n]="'overdue-process.action-modal.history.no-history'">
            </div>
        </div>
    </div>
</ng-template>

